import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "./Banner.css";
import SearchOption from "../Shard/SearchOption";
import { BannerData } from "./BannerData";
import "animate.css";
import BannerItems from "./BannerItems";

const Banner = ({ useWindowSize }) => {
  const sliderRef = useRef(null);
  const [isScroll, setIsScroll] = useState(false);
  const [moblieScreen, setMobileScreen] = useState(false);
  const [activeAnimation, setActiveAnimation] = useState(true);
  const width = useWindowSize;

  useEffect(() => {
    const changeBackground = () => {
      if (window.scrollY >= 1) {
        setIsScroll(true);
      } else {
        setIsScroll(false);
      }
    };
    if (width < 668) {
      setMobileScreen(true);
    } else {
      setMobileScreen(false);
    }
    window.addEventListener("scroll", changeBackground);
    return () => {
      window.removeEventListener("scroll", changeBackground);
    };
  }, [isScroll, width]);

  const settings = {
    beforeChange: function () {
      setActiveAnimation(false);
    },
    afterChange: function () {
      setActiveAnimation(true);
    },
    fade: true,
    infinite: true,
    autoplay: true,
    arrows: false,
    dots: false,
    speed: 1500,
    autoplaySpeed: 6000,
    pauseOnHover: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="banner w-100">
      <>
        {!isScroll && (
          <div className="search_init">
            <SearchOption />
          </div>
        )}
      </>
      <Slider {...settings} ref={sliderRef} onAfterChange>
        {BannerData.map((items, index) => (
          <BannerItems
            items={items}
            index={index}
            sliderRef={sliderRef}
            moblieScreen={moblieScreen}
            activeAnimation={activeAnimation}
          />
        ))}
      </Slider>
    </div>
  );
};

export default Banner;
